import { useMemo, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import CommentIcon from "@mui/icons-material/Comment";
import { Avatar, Box, Grid, Pagination, PaginationItem, Rating, Typography } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const UserConfigs = [
  {
    avatar: "https://img.awardtool.com/guides/user1_v2.jpeg",
    name: "Jonathan Carter",
    title: "California, USA",
    desc: "AwardTool is absolutely revolutionary, offering unparalleled flexibility with its ability to search multiple airports and dates simultaneously. I'm amazed by the variety and accuracy of the results. It's a game-changer for award travel planning! Best award search tool indeed!",
  },
  {
    avatar: "https://img.awardtool.com/guides/user3_v2.jpeg",
    name: "Emily Thompson",
    title: "New York, USA",
    desc: "Finding award spaces has never been easier, thanks to Panorama's regional search options. Whether I'm looking to explore Europe or visit family in the US, AwardTool is my go-to tool for quick and effective award flight search. It can easily save me hours of time.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user4_v2.jpeg",

    name: "Michael Bennett",
    title: "Cambridge, UK",
    desc: "The Pro version of AwardTool is worth every penny. The extra award travel search capabilities and alert features have helped me snag some incredible deals that I would have otherwise missed. Save thousands and hours indeed! It's an essential tool for any serious traveler.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_5.jpeg",

    name: "Chun Hei Wong",
    title: "Hong Kong, China",
    desc: "I was thrilled to discover AwardTool's Mega Search feature; it's like nothing else on the market. Being able to conduct up to 24 searches at once has saved me countless hours and introduced me to options I hadn't considered.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_6.jpeg",

    name: "Mateus Silva",
    title: "São Paulo, Brazil",
    desc: "AwardTool's intuitive interface and powerful search capabilities made it incredibly easy to find the best award flights. Its detailed filters allowed me to tailor searches perfectly to my travel preferences.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_7.jpeg",

    name: "Ethan Smith",
    title: "Vancouver, Canada",
    desc: "The alert system in AwardTool is a standout feature, ensuring I never miss out on the best redemption opportunities. It's clear that this tool is designed with the savvy traveler in mind, making it indispensable for anyone looking to take advantage of their miles.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_8.jpeg",

    name: "Sofía Martinez",
    title: "Cancún, Mexico",
    desc: "Never before have I felt so empowered in my travel decisions. AwardTool's comprehensive search results and user-friendly design have taken the guesswork out of booking award travel.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_9.jpeg",

    name: "Madison Clark",
    title: "Seattle, USA",
    desc: "From a novice to a seasoned traveler, AwardTool caters to all. Its detailed insights into award availability and seamless navigation make it my go-to for planning trips efficiently.",
  },
  {
    avatar: "https://img.awardtool.com/guides/user_10.jpeg",

    name: "David Johnson",
    title: "Austin, USA",
    desc: "Using AwardTool has streamlined my travel planning process significantly. The ease of discovering flights with the best value across various loyalty programs has been a major time-saver.",
  },
];

const HomeBanner = () => {
  const { isPc } = usePlatform();

  const [index, setIndex] = useState(0);

  const groupData = useMemo(() => {
    const newData = [];
    const groupCount = Math.ceil(UserConfigs.length / 3);
    for (let index = 0; index < groupCount; index++) {
      newData.push(UserConfigs.slice(index * 3, Math.min(index * 3 + 3, UserConfigs.length)));
    }
    return newData;
  }, []);
  return (
    <Box className="my-[60px]">
      <Typography
        className="flex items-center !mb-[-8px]"
        color="textPrimary"
        fontWeight={20000}
        component={"div"}
      >
        <div className="relative flex items-center md:mx-[5px] mx-[15px] text-[16px] md:text-[20px] mb-[20px] text-center">
          <CommentIcon color="primary" sx={{ mr: isPc ? 1 : 0.5 }} />
          Rated 5 Stars by Global Award Tavelers!
        </div>
      </Typography>

      <div className="text-center mb-[0px]">
        <Typography color="textSecondary">
          Award traveler from around the world have had fantastic experiences using AwardTool.
        </Typography>
        <Typography color="textSecondary">Here's what they have to say</Typography>
        <Rating name="read-only" value={5} readOnly />
      </div>

      {isPc ? (
        <div>
          <div className="flex justify-center">
            <Pagination
              hideNextButton
              hidePrevButton
              count={groupData.length}
              page={index + 1}
              onChange={(e, page) => setIndex(page - 1)}
            />
          </div>
          <AutoPlaySwipeableViews
            interval={11800}
            index={index}
            onChangeIndex={(v: number) => setIndex(v)}
            enableMouseEvents
          >
            {groupData.map((groupItem, uninKey) => (
              <Grid container spacing={2} sx={{ padding: "10px" }} key={uninKey}>
                {groupItem.map((item, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <div className="flex items-center space-x-[10px]">
                      <Avatar alt="" src={item.avatar} sx={{ width: 80, height: 80 }} />
                      <div className="space-y-[1px]">
                        <Typography color="textPrimary">{item.name}</Typography>
                        <Typography color="textSecondary">{item.title}</Typography>
                      </div>
                    </div>

                    <div className="mt-[20px]">
                      <Typography color="textSecondary">{item.desc}</Typography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            ))}
          </AutoPlaySwipeableViews>
        </div>
      ) : (
        <Grid container spacing={2} sx={{ padding: "10px" }}>
          {UserConfigs.slice(0, 3).map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <div className="flex items-center space-x-[10px]">
                <Avatar alt="" src={item.avatar} sx={{ width: 80, height: 80 }} />
                <div className="space-y-[1px]">
                  <Typography color="textPrimary">{item.name}</Typography>
                  <Typography color="textSecondary">{item.title}</Typography>
                </div>
              </div>

              <div className="mt-[20px]">
                <Typography color="textSecondary">{item.desc}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default HomeBanner;
